<template>
  <div v-if="flag">
    <a-spin :spinning="confirmLoading">
      <!-- 基本信息表单 -->
      <a-card title="基本信息" :bordered="true">
        <project-info-form ref="projectInfo"/>
      </a-card><br>
      <!-- 招/投标阶段 -->
      <a-card class="card" title="招/投标阶段" :bordered="true">
        <bidding-remark-form ref="biddingRemark"/>
        <bidding-remark-list ref="biddingRemarkTable" @getData="getMemberDataA"/>
      </a-card><br>
      <!-- 施工养护阶段 -->
      <a-card class="card" title="施工、养护阶段" :bordered="false">
        <work-remark-form ref="workRemark" :showSubmit="false"/>
        <work-remark-list ref="workRemarkTable" @getData="getMemberDataB"/>
      </a-card><br>
      <!-- 回款记录 -->
      <a-card class="card" title="回款记录" :bordered="false">
        <record-list ref="recordTable" @getData="getMemberDataC"/>
      </a-card><br>
      <!-- 预警提示设置 -->
      <a-card class="card" title="预警提示设置" :bordered="false">
        <warning-list ref="warningTable" @getData="getMemberDataD"/>
      </a-card><br>
      <footer-tool-bar>
        <a-button @click="handleCancel">取消</a-button>
        &nbsp;
        <a-button type="primary" :disabled="showable" @click="validate" :loading="confirmLoading">提交</a-button>
      </footer-tool-bar>
    </a-spin>
  </div>
</template>

<script>
import ProjectInfoForm from './Component/projectInfoForm'
import biddingRemarkForm from './Component/biddingRemarkForm'
import biddingRemarkList from './Component/biddingRemarkList'
import workRemarkForm from './Component/workRemarkForm'
import workRemarkList from './Component/workRemarkList'
import recordList from './Component/recordList'
import warningList from './Component/warningList'
import FooterToolBar from '@/components/FooterToolbar'
import { getObj, addObj, putObj } from '@/api/project/ProjectBuildInfo'
import moment from 'moment'
export default {
  name: 'BuildInfoAddOrUpdate',
  components: {
    ProjectInfoForm,
    biddingRemarkForm,
    biddingRemarkList,
    workRemarkForm,
    workRemarkList,
    recordList,
    warningList,
    FooterToolBar
  },
  data () {
    return {
      flag: false,
      description: '创建管理一个施工工程',
      confirmLoading: false,
      editable: false,
      addable: false,
      showable: false,
      visible: false,
      biddingRemarkData: [],
      biddingRemarkDelete: [],
      workRemarkData: [],
      workRemarkDelete: [],
      recordData: [],
      recordDelete: [],
      warningData: [],
      warningDelete: [],
      projectBuildInfo: {},
      buildId: '',
      type: 'add'
    }
  },
  activated () {
    this.clearData()
    this.buildId = this.$route.query.buildId
    this.type = this.$route.query.type
    if (this.buildId && this.type) {
      this.edit(this.buildId, this.type)
    } else {
      // 每次进入重新加载页面
      this.flag = false
      setTimeout(() => {
        this.flag = true
      }, 100)
      // 如果路由没有传参数，说明是新增
      // this.$refs.projectInfo.loadData()
    }
  },
  methods: {
    // 获取信息
    edit (id, type) {
      this.visible = true
      if (type && type === 'add') {
        this.showable = false
        this.addable = true
        this.type = type
      }
      if (type === 'edit') {
        this.showable = false
        this.editable = true
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          this.confirmLoading = false
          this.$nextTick(() => {
            const projectInfo = {
              id: record.projectInfo.id,
              projectName: record.projectInfo.projectName,
              projectContractName: record.projectBuildInfo.projectContractName,
              projectContractManager: record.projectBuildInfo.projectContractManager,
              projectBuildDate: record.projectBuildInfo.projectBuildDate
            }
            this.$refs.projectInfo.loadData(projectInfo, type)
            const biddingRemark = {
              id: record.projectBuildInfo.id,
              biddingPartyA: record.projectBuildInfo.biddingPartyA,
              biddingPartyB: record.projectBuildInfo.biddingPartyB,
              biddingContractAmount: record.projectBuildInfo.biddingContractAmount,
              biddingProjectLocation: record.projectBuildInfo.biddingProjectLocation,
              biddingPayMethod: record.projectBuildInfo.biddingPayMethod,
              biddingOtherInfo: record.projectBuildInfo.biddingOtherInfo,
              biddingFileList: record.projectBuildInfo.biddingFileList,
              winBiddingFileList: record.projectBuildInfo.winBiddingFileList,
              constructionFileList: record.projectBuildInfo.constructionFileList
            }
            this.$refs.biddingRemark.loadData(biddingRemark, type)
            const workRemark = {
              id: record.projectBuildInfo.id,
              workStartDate: record.projectBuildInfo.workStartDate,
              workEndDate: record.projectBuildInfo.workEndDate,
              curingStartDate: record.projectBuildInfo.curingStartDate,
              curingEndDate: record.projectBuildInfo.curingEndDate,
              settleAmount: record.projectBuildInfo.settleAmount,
              auditAmount: record.projectBuildInfo.auditAmount
            }
            this.$refs.workRemark.loadData(workRemark, type)
            this.$refs.biddingRemarkTable.loadData(record.projectBuildBiddingRemarkList, type)
            this.$refs.workRemarkTable.loadData(record.projectBuildWorkRemarkList, type)
            this.$refs.recordTable.loadData(record.projectBuildRefundRecordList, type)
            this.$refs.warningTable.loadData(record.projectBuildWarningList, type)
          })
        })
      }
    },
    // 最终全页面提交
    validate () {
      this.$refs.biddingRemarkTable.uploadData()
      this.$refs.workRemarkTable.uploadData()
      this.$refs.recordTable.uploadData()
      this.$refs.warningTable.uploadData()
      const { $refs: { projectInfo, biddingRemark, workRemark } } = this
      const projectInfoForm = new Promise((resolve, reject) => {
        projectInfo.form.validateFields((err, values) => {
          if (err) {
            reject(err)
            return
          }
          resolve(values)
        })
      })
      const biddingRemarkForm = new Promise((resolve, reject) => {
        biddingRemark.form.validateFields((err, values) => {
          if (err) {
            reject(err)
            return
          }
          resolve(values)
        })
      })
      const workRemarkForm = new Promise((resolve, reject) => {
        workRemark.form.validateFields((err, values) => {
          if (err) {
            reject(err)
            return
          }
          resolve(values)
        })
      })
      Promise.all([projectInfoForm, biddingRemarkForm, workRemarkForm]).then(values => {
        const postData = {}
        // 从返回的values里面取出表单数据
        const projectDataForm = values[0]
        const biddingDataForm = values[1]
        const workDataDForm = values[2]
        postData.projectInfo = null
        postData.projectInfo = projectDataForm
        // 把三个表单的字段付给 projectBuildInfo
        postData.projectBuildInfo = Object.assign({}, projectDataForm, biddingDataForm, workDataDForm)
        // 格式化时间日期
        postData.projectBuildInfo.projectBuildDate = this.Formatting(postData.projectBuildInfo.projectBuildDate)
        postData.projectBuildInfo.workStartDate = this.Formatting(postData.projectBuildInfo.workStartDate)
        postData.projectBuildInfo.workEndDate = this.Formatting(postData.projectBuildInfo.workEndDate)
        postData.projectBuildInfo.curingStartDate = this.Formatting(postData.projectBuildInfo.curingStartDate)
        postData.projectBuildInfo.curingEndDate = this.Formatting(postData.projectBuildInfo.curingEndDate)
        // // !!!! 给projectBuildInfo赋值id
        postData.projectBuildInfo.id = biddingDataForm.id
        postData.projectBuildBiddingRemarkList = this.biddingRemarkData
        postData.projectBuildBiddingRemarkDelete = this.biddingRemarkDelete
        postData.projectBuildWorkRemarkList = this.workRemarkData
        postData.projectBuildWorkRemarkDelete = this.workRemarkDelete
        postData.projectBuildRefundRecordList = this.recordData
        postData.projectBuildRefundRecordDelete = this.recordDelete
        postData.projectBuildWarningList = this.warningData
        postData.projectBuildWarningDelete = this.warningDelete
        try {
          if (this.type === 'edit') {
            this.confirmLoading = true
            putObj(postData).then((res) => {
              this.confirmLoading = false
              this.$message.success('修改成功', 1).then(() => {
                this.$router.push({ name: 'projectBuildInfo' })
              })
            })
          } else {
            this.confirmLoading = true
            addObj(postData).then((res) => {
              this.confirmLoading = false
              this.$message.success('保存成功', 1).then(() => {
                this.$router.push({ name: 'projectBuildInfo' })
              })
            })
          }
        } catch (e) {
          this.$message.error(e.msg)
        }
      }).catch(() => {
        const errors = Object.assign({}, projectInfo.form.getFieldsError(), biddingRemark.form.getFieldsError(), workRemark.form.getFieldsError())
        const tmp = { ...errors }
        this.errorList(tmp)
      })
    },
    handleCancel () {
      // this.$router.push({ name: 'projectBuildInfo' })
      this.$router.go(-1)
    },
    getMemberDataA (data) {
      this.biddingRemarkData = data.dataSource
      this.biddingRemarkDelete = data.deleteList
    },
    getMemberDataB (data) {
      this.workRemarkData = data.dataSource
      this.workRemarkDelete = data.deleteList
    },
    getMemberDataC (data) {
      this.recordData = data.dataSource
      this.recordDelete = data.deleteList
    },
    getMemberDataD (data) {
      this.warningData = data.dataSource
      this.warningDelete = data.deleteList
    },
    // 格式化时间
    /**
     * @return {string}
     */
    Formatting (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      }
    },
    clearData () {
      this.biddingRemarkData = []
      this.biddingRemarkDelete = []
      this.workRemarkData = []
      this.workRemarkDelete = []
      this.recordData = []
      this.recordDelete = []
      this.warningData = []
      this.warningDelete = []
      this.projectBuildInfo = {}
    }
  }
}
</script>

<style scoped>

</style>
